import usePrivateAxios from '@/common/api/usePrivateAxios'
import { RoleData, RoleResponse } from '@/common/types/roles'
import { useQuery } from '@tanstack/react-query'

interface UseEstablishmentRoleProps {
  id: string
}

export const useEstablishmentRole = ({ id }: UseEstablishmentRoleProps) => {
  const privateAxios = usePrivateAxios()

  return useQuery<RoleResponse, unknown, RoleData>({
    queryKey: ['establishmentRole', id],
    queryFn: () => {
      return privateAxios.get(`/establishment/roles/${id}`)
    },
    select: (data) => data?.data?.data,
  })
}
